import { useFormik } from 'formik';
import { User } from 'api/users/types';
import { Modal } from '../../ui/Modal';
import { useMutation } from 'react-query';
import { RegisterRequest } from 'api/auth/types';
import { createModerator, putOrgAdmin } from 'api/users';
import { Field } from '../../ui/Field';

interface Props {
  onClose: () => void;
  user: User | null;
  refetch: () => void;
}

export const ModeratorFormModal = ({ onClose, user, refetch }: Props) => {
  const onSuccess = () => {
    refetch();
    onClose();
  };

  const { mutate: add, isLoading: isLoadingAdd } = useMutation(createModerator, { onSuccess });
  const { mutate: update, isLoading: isLoadingUpdate } = useMutation(putOrgAdmin, { onSuccess });

  const formik = useFormik({
    initialValues: {
      name: user?.name || '',
      email: user?.email || '',
      password: '',
      repeatPassword: '',
      isCensorshipEnabled: user?.isCensorshipEnabled ?? false,
    } as RegisterRequest & { isCensorshipEnabled: boolean },
    onSubmit: (values) =>
      user ? update({ userId: user._id, ...values }) : add(values),
  });;

  return (
    <Modal onClose={onClose} title={`${user ? 'Edit' : 'Add'} Moderator`}>
      <div className="relative bg-white rounded-xl w-full md:w-[400px]">
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3 md:gap-3 mt-3 md:my-1">
          <Field label="Full Name" formik={formik} name="name" type="text" />
          <Field label="Email" formik={formik} name="email" type="email" />
          <Field label="Password" formik={formik} name="password" type="password" />
          {user ? null : <Field label="Confirm Password" formik={formik} name="repeatPassword" type="password" />}
          <div className="flex items-center justify-between w-full ">
            <label
              htmlFor="isCensorshipEnabled"
              className="text-sm font-medium fieldLabel "
            >
              Censorship Status: {formik.values.isCensorshipEnabled ? "Enabled" : "Disabled"}
            </label>
            <input
              id="isCensorshipEnabled"
              name="isCensorshipEnabled"
              type="checkbox"
              checked={formik.values.isCensorshipEnabled}
              onChange={(e) =>
                formik.setFieldValue("isCensorshipEnabled", e.target.checked)
              }
              className="sr-only"
            />
            <button
              type="button"
              onClick={() =>
                formik.setFieldValue(
                  "isCensorshipEnabled",
                  !formik.values.isCensorshipEnabled
                )
              }
              className={`relative  inline-flex items-center justify-center h-6 w-16 rounded-full transition-all duration-300 ease-in-out text-white  focus:ring-black-500  ${formik.values.isCensorshipEnabled? "bg-green-500 ": "bg-gray-500 "}`}
            >
              <span
                className={`absolute left-1 inline-block h-3 w-3 bg-white rounded-full shadow-md transform transition-transform ${formik.values.isCensorshipEnabled? "translate-x-10": "translate-x-1"}`}
              />
              <span
                className={`relative z-10 text-xs font-xs ${formik.values.isCensorshipEnabled ? "mr-5" : "ml-2"}`}
              >
                {formik.values.isCensorshipEnabled ? "ON" : "OFF"}
              </span>
            </button>
          </div>
          <button type="submit" className="secondaryBtn w-full" disabled={isLoadingAdd || isLoadingUpdate}>
            {user ? 'Edit' : 'Add'} Moderator
          </button>
        </form>
      </div>
    </Modal>
  );
};
